// System directives

"use client";

// System dependencies

import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

// Application dependencies

import { authSetUser } from "@/_auth/redux/auth/auth.slices";
import { formatErrorMessage } from "@/lib/functions";
import { getAuthUserByIdAction } from "@/_auth/actions/auth.actions";

/**
 * Fetches an auth user's data by Id and dispatches actions for loading and error states.
 *
 * @param {string} id - The id the auth user to retrieve.
 * @returns {Promise<UserRedux | void>} A Promise that resolves with the AuthUser object if the auth user is found or a null.
 */

export const getAuthUserById = createAsyncThunk(
  "auth/getAuthUserById",
  async ({ id }: { id: string }, { dispatch }) => {
    // Try and get the auth user by the id.

    try {
      // Make the call to the server action.

      const authUser = await getAuthUserByIdAction(id);

      // If we have an auth user we can update the auth user state and return.

      if (authUser) {
        // Load the auth user into auth user state.

        dispatch(authSetUser(authUser));

        // And return doing nothing more.

        return;
      }
    } catch (error) {
      // There was an error so display a toast.

      toast.error("Error: " + formatErrorMessage(error));
    }
  }
);
